export default __webpack_public_path__ + "static/media/Shirt.c4bb3af3.svg";